import { render, staticRenderFns } from "./SoundLightAlarm.vue?vue&type=template&id=7371ca59&"
import script from "./SoundLightAlarm.vue?vue&type=script&lang=js&"
export * from "./SoundLightAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports